/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Label_Boat_NameInputs */

const es_ab_label_boat_name = /** @type {(inputs: Ab_Label_Boat_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del barco`)
};

const gl_ab_label_boat_name = /** @type {(inputs: Ab_Label_Boat_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do barco`)
};

const en_ab_label_boat_name = /** @type {(inputs: Ab_Label_Boat_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat name`)
};

/**
* | output |
* | --- |
* | "Boat name" |
*
* @param {Ab_Label_Boat_NameInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_label_boat_name = /** @type {((inputs?: Ab_Label_Boat_NameInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Label_Boat_NameInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_label_boat_name(inputs)
	if (locale === "en") return en_ab_label_boat_name(inputs)
	return es_ab_label_boat_name(inputs)
});